import styled from 'styled-components';
import { StyledTransitionGroup } from '@optimus-web/helpers';

interface ViewProps {
    hide?: boolean;
    fill?: boolean;
}

export const View = styled('div').withConfig<ViewProps>({
    shouldForwardProp: (prop, defaultValidatorFn) => !['fill'].includes(prop) && defaultValidatorFn(prop),
})`
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: ${(props) => (props.fill ? 0 : 'auto')};

    ${(props) => props.hide && 'display: none;'}
`;
View.defaultProps = { fill: true };

export const TransitionViewWrapper = styled(StyledTransitionGroup)`
    position: relative;
    height: 100%;
`;

export const ViewWrapper = styled.div`
    position: relative;
`;
